<template>
  <div>
    <div class="my-4">
      <h4>View PDF Logs</h4>
    </div>


    <div class="table-responsive">
      <table :id="'advert_logs'" class="display table table-striped table-bordered" style="width:100%; text-align: center;">
        <thead>
          <tr>
            <th>No.</th>
            <th>View PDF Date</th>
            <th>IC Number</th>
            <th>Customer Name</th>
            <th>Mobile No.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in logs" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ log.viewed_at_formatted }}</td>
            <td>{{ log.ic_number }}</td>
            <td>{{ log.name }}</td>
            <td>{{ log.mobile }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { viewLogs } from '../../../services/PromotionService';

export default {
  data() {
    return {
      advert_id: this.$route.params.id,
      logs: [],
    }
  },

  methods: {
    async fetchLogs() {
      try {
        const response = await viewLogs(this.advert_id);
        if(response.data.success) {
          this.logs = response.data.data;
        }
      } catch (e) {
        console.error(e)
      }
    },

    setDatatable() {
      $("#advert_logs").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4]
            }
          }
        ]
      });
    },
  },

  async mounted() {
    await this.fetchLogs();
    this.setDatatable()
  }
}

</script>
